import { fromVariables } from 'convert-to-jcamp';
/**
 * @param analysis
 * @param options
 */
export function toJcamps(analysis, options = {}) {
    let jcamps = [];
    for (let measurement of analysis.measurements) {
        jcamps.push(getJcamp(measurement, options));
    }
    return jcamps;
}
/**
 * @param measurement
 * @param options
 */
function getJcamp(measurement, options) {
    const { info = {}, meta = {} } = options;
    let jcampOptions = {
        options: {},
        info: {
            title: measurement.description,
            dataType: measurement.dataType,
            ...info,
        },
        meta: { ...measurement.meta, ...meta },
    };
    return fromVariables(measurement.variables, jcampOptions);
}
//# sourceMappingURL=toJcamps.js.map